import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import PubSub from "services/PubSub/";
import TagManagerService from "services/TagManager";
import { Link, useHistory } from 'react-router-dom';
import CMSService from 'services/CMS'
import CMSFactory from 'factories/CMS'
import style from './style.scss';//NOSONAR

const ItemCategory = (props) => {
    const [subCats, setSubCats] = useState(null);
    const [show, setShow] = useState(false);
    const [categories, setCategories] = useState([]);
    const history = useHistory();

    const openOption = (category) => {
        if(!(category?.items && category.items.length) && category && category.url){
            history.push(category.url);
            closeMenu(category.url);
        }
        setSubCats(category);
        if (category) {
            setShow(true);
        }
    }

    useEffect(() => {
        if(props && props.categories){
            CMSService.getDateTime().then(res => {
                setCategories(props.categories.filter((item) => {
                    if (item.active !== true) return false
                    if (!CMSService.validDatesItem(item, CMSFactory.milliseconds(res.datetime))) return false
                    return item
                }).filter(Boolean))
            })
        }
        return function cleanup(){}
    },[props && props.categories && props.categories.length]);

    const closeMenu = (url) => {
        if (typeof (url) === 'string') {
            const title_path = url.replace('/', '').replace('_', ' ');
            const title_crumbs = title_path.charAt(0).toUpperCase() + title_path.slice(1).replace(/-/g, " ");
            TagManagerService.menu(title_crumbs, title_crumbs.split('/').pop(), 'Menú Superior');
        }

        PubSub.dispatch('toggle_menu');
        PubSub.dispatch('toggle_preheader', { state: false })
    }

    return (
        <>
            {(props.title !== "Ofertas") ? (<><ul className={'new-mobile-menu-cats-wrap' + (show ? ' open' : '')}>
                {categories && categories.map((category, i) => {
                    return (
                        <li className={'new-mobile-menu-title'} onClick={() => openOption(category)} key={i}>
                            {category.title} <i className="font-icn arrow-up"/>
                        </li>
                    );
                })}
            </ul></>) : (<><ul className={'new-mobile-menu-title'} onClick={() => openOption(props.title)}>
                {props.title}
                <i className="font-icn arrow-up"/>
            </ul></>)}
            {(props.title !== "Ofertas") ? (<div className={'new-mobile-submenu-cats-wrap' + (show ? ' open' : '')}>
                {subCats && <>
                    <div className={'new-mobile-menu-title open'} onClick={() => setShow(false)}>
                        <span>{subCats.title}</span> <i className="font-icn arrow-up"></i>
                    </div>
                    <ul className='new-mobile-menu-caterories-wrapper'>
                        {!!subCats?.items && subCats.items.map((item) => {
                            return (
                                <li className="new-mobile-menu-cats" key={item.title}>
                                    <Link to={item.url} className="new-mobile-cats-title mobile-click" onClick={() => closeMenu(item.url)}>{item.title}</Link>
                                </li>)}
                        )}
                    </ul>
                </>}
            </div>) : (<div className={'new-mobile-submenu-cats-wrap' + (show ? ' open' : '')}>
                <div className={'new-mobile-menu-title open'} onClick={() => setShow(false)}>
                    <span>{props.title}</span> <i className="font-icn arrow-up"></i>
                </div>
                <ul>
                    {categories.map((item) => {
                        return (
                            <li className="new-mobile-menu-cats" key={item.title}>
                                <Link to={item.url} className="new-mobile-cats-title mobile-click" onClick={() => closeMenu(item.url)}>{item.title}</Link>
                            </li>)},
                    )}
                </ul>
            </div>)}

        </>
    )
}

ItemCategory.propTypes = {
    categories: PropTypes.array,
    title: PropTypes.string,
    active: PropTypes.bool,
    id: PropTypes.number
};

export default ItemCategory;
